import gql from 'graphql-tag';

export const VERIFY_IMPERSONATION_TOKEN = gql`
mutation verifyImpersonationToken($token: String!) {
  verifyImpersonationToken(token: $token) {
    ok
    errorMessage
  }
}
`;
export const CREATE_IMPERSONATION_TOKEN = gql`
mutation createImpersonationToken($id: ID!) {
  createImpersonationToken(globalId: $id) {
    ok
    errorMessage
    impersonationToken
  }
}
`;

